import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/remainingSessionsSagas";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";

const MembershipTypeFilter = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.sessions.filters.membership_types);
  const selectedFilters = useSelector((state) => state.sessions.selectedFilters.membership_types);

  return (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selectedFilters}
      placeholder="Not selected"
      height={324}
      numberDisplayed={0}
      includeSelectAll
      enableOnly
      onSelectChange={(data) => dispatch(actionCreators.updateFilters({ membership_types: data }))}
    />
  );
};

export default MembershipTypeFilter;
